import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { axiosSafeRequest } from "../axiosSafeRequest";

type MachineAuthorizeResponse = {
  authorized: boolean;
};

/**
 * Checks whether the current user is authorized to modify machines.
 * @returns An HTTP response with authorization status.
 */
export const apiMachineAuthorizeGet = async (): Promise<AxiosResponse<MachineAuthorizeResponse> | undefined> => {
  return axiosSafeRequest(() => axiosClient.get("/machine/authorize"));
};
